var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("파트너 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("가입 절차")])];
      },
      proxy: true
    }, {
      key: "txt",
      fn: function () {
        return [_vm._v("가입하기 전 파트너 등록 자격 요건이나 사전 준비사항을 미리 확인하세요!")];
      },
      proxy: true
    }])
  }, [_c('membership-steps')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }